import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsAutomationRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsAutomationRoute.tsx';
import { softwareProjectLayout } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import JiraAutomation, {
	LazyProjectSettingsJiraAutomation,
} from './ui/project-settings/jira-automation/index.tsx';
import {
	getSettingsNavigationResources,
	SOFTWARE_PRODUCT,
} from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsAutomationRouteEntry: Route = createEntry(
	projectSettingsAutomationRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: `project-settings-automation-${SOFTWARE_PRODUCT}`,
		// eslint-disable-next-line no-restricted-syntax
		component: JiraAutomation,
		layout: softwareProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsJiraAutomation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
